module.exports = __webpack_public_path__ + "img/reward-bubble-6.7aacad21.png";